import { Button, Card, Input } from '@bpinternal/ui-kit-next'
import { cn } from '../../../utils'
import { useState } from 'react'
import { getApiClient } from '~/stores'

type Props = { botId: string; workspaceId: string }

export const WorkflowRun = ({ botId, workspaceId }: Props) => {
  const [workflowName, setWorkflowName] = useState('')
  const [jsonInput, setJsonInput] = useState('')
  const [jsonError, setJsonError] = useState<string | null>(null)
  const [nameError, setNameError] = useState<string | null>(null)

  const parseJsonInput = (): Record<string, unknown> | null => {
    if (!jsonInput.trim()) return null

    try {
      const parsed = JSON.parse(jsonInput) as Record<string, unknown>
      setJsonError(null)
      return parsed
    } catch (error) {
      setJsonError('Invalid JSON format')
      return null
    }
  }

  const onRun = () => {
    if (!workflowName) {
      setNameError('Workflow name is required')
    }

    const client = getApiClient({ botId, workspaceId })
    const parsedInput = parseJsonInput()

    if (nameError || jsonError) {
      return
    }

    client.createWorkflow({
      status: 'pending',
      name: workflowName,
      input: parsedInput || {},
    })
  }

  return (
    <Card className="mb-4 p-4">
      <p className="mb-1 font-bold">Run workflow</p>
      <div className="space-y-4">
        <div className="space-y-2">
          <Input
            placeholder="Workflow Name"
            className={cn(nameError && 'border-destructive focus-visible:ring-destructive')}
            required
            value={workflowName}
            onChange={(e) => {
              setWorkflowName(e.target.value)
              setNameError(null)
            }}
          />
          {nameError && <p className="text-sm text-destructive">{nameError}</p>}
        </div>
        <div className="space-y-2">
          <label className="text-sm font-medium text-muted-foreground">Input JSON (optional)</label>
          <textarea
            className={cn(
              'flex min-h-[120px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
              jsonError && 'border-destructive focus-visible:ring-destructive'
            )}
            placeholder='{"key": "value", "nested": {"data": 123}}'
            value={jsonInput}
            onChange={(e) => {
              setJsonInput(e.target.value)
              setJsonError(null)
            }}
          />
          {jsonError && <p className="text-sm text-destructive">{jsonError}</p>}
          <Button onClick={onRun}>Run</Button>
        </div>
      </div>
    </Card>
  )
}
